/* unplugin-vue-components disabled */import { render } from "./Follow.vue?vue&type=template&id=685fcef0"
import script from "./Follow.vue?vue&type=script&lang=js"
export * from "./Follow.vue?vue&type=script&lang=js"

import "./Follow.vue?vue&type=style&index=0&id=685fcef0&lang=css"

import exportComponent from "E:\\projects\\git\\company\\www_dixiang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__